import { useSettings } from "hooks";
import type { MerchantSettings } from "features/merchants/types";

const useMerchants = () => {
    const { getSettings } = useSettings<MerchantSettings>();

    const selectMerchantGroupName = () => getSettings().groups;

    return {
        selectMerchantGroupName
    };
};

export default useMerchants;
